const SkeletonLoader = () => {
    return (
        <div className="skeleton-container">

            {/* 🔥 FILTER SKELETON */}
            <div className="skeleton-filters">
                <div className="sk-col md"></div>
                <div className="sk-col md"></div>
                <div className="sk-col md"></div>
                <div className="sk-col md"></div>
            </div>

            {/* 🔥 TABLE HEADER */}
            <div className="skeleton-row header">
                <div className="sk-col sm"></div>
                <div className="sk-col md"></div>
                <div className="sk-col md"></div>
                <div className="sk-col md"></div>
                <div className="sk-col sm"></div>
                <div className="sk-col sm"></div>
            </div>

            {/* 🔥 TABLE ROWS */}
            {[...Array(8)].map((_, i) => (
                <div key={i} className="skeleton-row">
                    <div className="sk-col sm"></div>
                    <div className="sk-col md"></div>
                    <div className="sk-col lg"></div>
                    <div className="sk-col lg"></div>
                    <div className="sk-col md"></div>
                    <div className="sk-col sm"></div>
                </div>
            ))}
        </div>
    );
};

export default SkeletonLoader;